/**
 * ComplianceBadge — small inline icon flagging un-acknowledged safety docs
 * on a job. Shared across the Jobs table, calendars, dispatch board, and
 * the operative schedule.
 *
 * Render rules:
 *   - linked = 0           → nothing (most jobs)
 *   - linked > 0, blocked  → red ShieldWarning, hover tooltip explains
 *   - linked > 0, all OK   → green ShieldCheck (quiet confidence)
 *
 * Best-effort: when the batch ack-summary endpoint hasn't returned yet (or
 * failed silently) the badge renders nothing — never a layout-shift bomb.
 */
import { ShieldWarning, ShieldCheck } from "@phosphor-icons/react";

export default function ComplianceBadge({ summary, jobId, size = 12 }) {
  if (!summary || !summary.linked) return null;
  if (summary.blocked) {
    return (
      <span
        title={`${summary.unacked} of ${summary.linked} compliance doc${summary.linked === 1 ? "" : "s"} not yet acknowledged — operative is blocked from starting`}
        data-testid={`job-compliance-badge-blocked-${jobId}`}
        className="inline-flex"
      >
        <ShieldWarning size={size} weight="fill" className="text-red-600 dark:text-red-400" />
      </span>
    );
  }
  return (
    <span
      title={`All ${summary.linked} compliance doc${summary.linked === 1 ? "" : "s"} acknowledged`}
      data-testid={`job-compliance-badge-ok-${jobId}`}
      className="inline-flex"
    >
      <ShieldCheck size={size} weight="fill" className="text-emerald-600 dark:text-emerald-400" />
    </span>
  );
}
